import { createContext } from "react";

export const ContextoIncidencias = createContext();
ContextoIncidencias.displayName = "ContextoIncidencias";
